import { render } from "./CheckPixelIcon.vue?vue&type=template&id=13878b76"
const script = {}
script.render = render

export default script